const Locales: ILocaleMap = {
  zh: 'Chinese, Simplified (ZH_HANS)',
  hr: 'Croatian (HR)',
  da: 'Danish (DK)',
  nl: 'Dutch (NL)',
  en: 'English (EN)',
  et: 'Estonian (ET)',
  fi: 'Finnish (FI)',
  fr: 'French (FR)',
  ka: 'Georgian (KA)',
  de: 'German (DE)',
  hi: 'Hindi (HI)',
  hu: 'Hungarian (HU)',
  is: 'Icelandic (IS)',
  it: 'Italian (IT)',
  ja: 'Japanese (JA)',
  ko: 'Korean (KR)',
  nb: 'Norwegian (NO)',
  pl: 'Polish (PL)',
  pt: 'Portuguese (PT)',
  'pt-BR': 'Portuguese (BR)',
  ro: 'Romanian (RO)',
  ru: 'Russian (RU)',
  sr: 'Serbian (SP)',
  sl: 'Slovene (SI)',
  es: 'Spanish (ES)',
  sv: 'Swedish (SV)',
  th: 'Thai (TH)',
  tr: 'Turkish (TR)',
  vi: 'Vietnamese (VN)',
}

interface ILocaleMap {
  [key: string]: string
}

export const ALL_LOCALE_OPTIONS = Object.keys(Locales).map((l) => ({
  label: Locales[l],
  value: l,
}))

export const resolveLocaleOptions: any = (multiWidgetLocales: Array<string>) =>
  multiWidgetLocales.map((locale: string) => {
    const value = locale ? locale : 'en'
    return {
      label: Locales[value],
      value,
    }
  })
